// extracted by mini-css-extract-plugin
export default {"dialog--overlay":"EIBPDPiqcXacVOGHqcBhm97hE-8t33yUdq-OgdHbeC0="};